module.exports = __webpack_public_path__ + "img/app_test.ab496ac2.webp";